import { Injectable } from '@angular/core';
import { DisplayService } from '../../services/display/display.service';
import { CommsService } from '../../services/comms/comms.service';
import { NoteService } from '../../services/note/note.service';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { TabService } from '../tab/tab.service';

@Injectable()
export class SmartContractService {

	listRoot = 'contract-changes';
	objRoot = 'contract-change';
	dataObj = 'smartcontract';

	tabsData = {
		listTabs: [
			{
				prop: 'all',
				name: 'All',
				active: false,
				persona: ['all'],
				notPersona: [],
				cached: false,
				listTab: true,
				statusTab: false,
				loading: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		]
	};

	constructor(
		private displayService: DisplayService,
		private commsService: CommsService,
		private noteService: NoteService,
		private dataService: DataService,
		private configService: ConfigService,
		private tabService: TabService
	) { }


	// TABBING METHODS

	getActiveTab(tabsData): any {
		let activeTab = {};
		tabsData.forEach(function (d, i) {
			if (d.active) {
				activeTab = d;
			}
		});
		return activeTab;
	}

	tabClick(event, tabProp, tabsData, type) {
		console.log('TAB CLICK', event, tabProp, tabsData);
		const self = this;
		tabsData.forEach(function (d, i) {
			d.active = false;
			if (d.prop === tabProp) {
				d.active = true;
				console.log('ACTIVATE TAB', d);
				if (d.listTab) {
					self.loadContractsForTab(d);
				}
			}
		});
	}

	selectDefaultTab(tabsData) {
		const self = this;
		tabsData.forEach(function (d, i) {
			tabsData[i].active = false;
			tabsData[i].cached = false;
		});
		let foundDefault = false;
		let defaultIndex = -1;
		tabsData.forEach(function (d, i) {
			console.log('CHECK TAB FOR DEFAULT', d, self.tabService.showTab(d.persona, d.notPersona));
			if (self.tabService.showTab(d.persona, d.notPersona) && !foundDefault) {
				foundDefault = true;
				defaultIndex = i;
				self.loadContractsForTab(d);
			}
		});
		tabsData[defaultIndex].active = true;
		console.log('SELECTED DEFAULT TAB', tabsData);
	}

	selectActiveTab(tabsData, tabProp) {
		const self = this;
		tabsData.forEach(function (d, i) {
			d.active = false;
			if (d.prop === tabProp) {
				d.active = true;
				console.log('ACTIVATE TAB', d);
				self.loadContractsForTab(d);
			}
		});
	}

	showTabSearch(tabsData) {
		this.getActiveTab(tabsData)['searching'] = !this.getActiveTab(tabsData)['searching'];
	}

	checkTabs(tabsData) {
		// expected method, no logic needed for po page tabs
		// see same method in contractorService for example of use
	}

	loadContractsForTab(tab) {
		if (tab.prop === 'all') {
			this.loadSmartContracts(tab);
		}
	}

	// UI INTERACTIONS

	openSmartContract(scData) {
		console.log('SHOW SMART CONTRACT: ', scData);
	}

	tableClick(event) {
		console.log('SMART CONTRACT TABLE CLICK: ', event);
		const clickedRow = event.row;
		this.openSmartContract(clickedRow);
	}

	tableSelect(event) {
		console.log('SMART CONTRACT TABLE SELECT: ', event);
		// for some reason this.dataService.selectedTableRows is not updated by select all
		this.dataService.selectedTableRows = event.selected;
	}

	tableRefresh(event) {
		console.log('SMART CONTRACT TABLE REFRESH: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.loadContractsForTab(activeTab);
	}

	tablePage(event) {
		console.log('SMART CONTRACT TABLE PAGE: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.getActiveTab(this.tabsData.listTabs)['page'] = event.offset;
		this.loadContractsForTab(activeTab);
	}

	tableSearch(event) {
		console.log('SMART CONTRACT TABLE SEARCH: ', event);
		const activeTab = this.getActiveTab(this.tabsData.listTabs);
		this.loadContractsForTab(activeTab);
	}

	getSmartContractProps(scType) {
		console.log('GET SC PROPS', scType);
		const self = this;
		switch (scType) {
			case 'Hours Restriction':
				return {
					prop: 'hoursrestriction',
					dataObj: this.configService.contractorSCDataObj
				};
			case 'poroledelegation':
				return {
					prop: 'poroledelegation',
					dataObj: this.configService.poSCDataObj
				};
		}
	}

	getSCConfig(dataConfig, scProp) {
		// console.log('GET SC CONFIG', dataConfig, scProp);
		let scConfig = {};
		dataConfig.objects.forEach(function (d, i) {
			if (d.prop === scProp) {
				scConfig = d;
			}
		});
		return scConfig;
	}


	// DATA INTEGRATIONS

	loadSmartContracts(data) {
		const self = this;

		// this.displayService.startLoading();
		this.displayService.activateLoadingTab(data, this.tabsData.listTabs);

		this.commsService.getSmartContractList(data).subscribe((res) => {
			// this.displayService.endLoading();
			this.displayService.deactivateLoadingTab(data, this.tabsData.listTabs);

			console.log('LOAD SMART CONTRACTS RES: ', res);

			const successData = self.commsService.getSuccessData(res);
			const count = self.commsService.getSuccessCount(res);
			const smartContracts = this.configService.getTableData(successData, this.dataObj);

			const dataRef = self.dataObj + '-' + data.prop + '-' + data.type;
			self.dataService.updatePageData(dataRef, data, smartContracts);
			self.dataService.updateDataCount(dataRef, count);
		}, (err) => {
			// this.displayService.endLoading();
			this.displayService.activateLoadingTab(data, this.tabsData.listTabs);
			self.commsService.handleAPIError('', err);
		});
	}

	loadPendingSmartContracts(data) {
		const self = this;

		this.displayService.startLoading();
		this.commsService.getPendingSmartContractList(data).subscribe((res) => {
			this.displayService.endLoading();
			console.log('LOAD PENDING SMART CONTRACTS RES: ', res);

			const successData = self.commsService.getSuccessData(res);
			const count = self.commsService.getSuccessCount(res);
			const smartContracts = this.configService.getTableData(successData, this.dataObj);

			const dataRef = self.dataObj + '-' + data.prop + '-' + data.type;
			self.dataService.updatePageData(dataRef, data, smartContracts);
			self.dataService.updateDataCount(dataRef, count);
		}, (err) => {
			this.displayService.endLoading();
			self.commsService.handleAPIError('', err);
		});
	}

	approveSmartContract(data, prop, callSource) {
		console.log('APPROVE SMART CONTRACT', data, prop);
		this.displayService.startLoading();
		const self = this;
		this.commsService.approveSmartContract(data, prop).subscribe((res) => {
			let jsonRes = {};
			try {
				jsonRes = res;
				console.log('APPROVE SMART CONTRACT RES: ', jsonRes);
				const successData = jsonRes[self.configService.detailDataProp];
				self.noteService.displaySuccess(self.getSuccessMessage(prop, successData) + '.');
				callSource.successCall();
			} catch (e) {
				self.noteService.displaySuccess(self.getSuccessMessage(prop, jsonRes) + ', but there was an error processing the server response. ' + e);
			} finally {
				this.displayService.endLoading();
			}
		}, (err) => {
			this.displayService.endLoading();
			self.commsService.handleAPIError('', err);
		});
	}

	deleteSmartContract(data, prop, callSource) {
		console.log('DELETE SMART CONTRACT', data, prop);
		this.displayService.startLoading();
		const self = this;
		this.commsService.deleteSmartContract(data, prop).subscribe((res) => {
			let jsonRes = {};
			try {
				jsonRes = res;
				console.log('DELETE SMART CONTRACT RES: ', jsonRes);
				const successData = jsonRes[self.configService.detailDataProp];
				self.noteService.displaySuccess(self.getSuccessMessage(prop, successData) + '.');
				callSource.successCall();
			} catch (e) {
				self.noteService.displaySuccess(self.getSuccessMessage(prop, jsonRes) + ', but there was an error processing the server response. ' + e);
			} finally {
				this.displayService.endLoading();
			}
		}, (err) => {
			this.displayService.endLoading();
			self.commsService.handleAPIError('', err);
		});
	}

	updateSmartContract(data, prop, callSource) {
		console.log('UPDATE SMART CONTRACT', data, prop);
		this.displayService.startLoading();
		const self = this;
		this.commsService.updateSmartContract(data, prop).subscribe((res) => {
			let jsonRes = {};
			try {
				jsonRes = res;
				console.log('UPDATE SMART CONTRACT RES: ', jsonRes);
				const successData = jsonRes[self.configService.detailDataProp];
				self.noteService.displaySuccess(self.getSuccessMessage(prop, successData) + '.');
				callSource.successCall();
			} catch (e) {
				self.noteService.displaySuccess(self.getSuccessMessage(prop, jsonRes) + ', but there was an error processing the server response. ' + e);
			} finally {
				this.displayService.endLoading();
			}
		}, (err) => {
			this.displayService.endLoading();
			self.commsService.handleAPIError('', err);
		});
	}

	submitSmartContract(data, prop, callSource) {
		console.log('SUBMIT SMART CONTRACT', data, prop);
		this.displayService.startLoading();
		const self = this;
		this.commsService.smartContract(data, prop).subscribe((res) => {
			let jsonRes = {};
			try {
				jsonRes = res;
				const successData = jsonRes[self.configService.detailDataProp];
				console.log('SUBMIT SMART CONTRACT RES: ', jsonRes);
				if (jsonRes['status'] === 'ERROR') {
					callSource.errorCall(jsonRes);
				} else if (jsonRes['status'] === self.configService.partialString) {
					callSource.partialCall(res);
				} else {
					self.noteService.displaySuccess(self.getSuccessMessage(prop, successData) + '.');
					callSource.successCall();
				}
			} catch (e) {
				self.noteService.displaySuccess(self.getSuccessMessage(prop, jsonRes) + ', but there was an error processing the server response. ' + e);
			} finally {
				this.displayService.endLoading();
			}
		}, (err) => {
			this.displayService.endLoading();
			if (err && err.error) {
				const error = err.error;
				if (error && error.error) {
					if (error.error.detail && error.error.detail.length > 0) {
						callSource.errorCall(err);
					} else {
						self.commsService.handleAPIError('', err);
					}
				} else {
					self.commsService.handleAPIError('', err);
				}
			}
		});
	}

	getSuccessMessage(prop, jsonRes) {
		let msg = 'The interim contract change has been submitted successfully';
		if (jsonRes && jsonRes.Message) {
			msg = jsonRes.Message;
		}
		switch (prop) {
			case 'approvetimesheet':
				return 'The timesheet(s) are processing. If the process takes time, the queue status will appear as a clock icon at the top of the page.';
			case 'migratetimesheet':
				return 'The timesheet(s) have been migrated successfully';
			case 'pomigrate':
				return 'Timesheets and invoices from cancelled PO have been successfully migrated to Target PO';
			case 'dtvscheduleupdate':
				return 'The selected DTV(Delegated Timesheet Verifier) schedule(s) have been updated successfully';
			case 'poarchive':
				return 'The selected purchase order(s) has been moved to inactive tab successfully';
			case 'porestore':
				return 'The selected purchase order(s) has been moved back to primary tab successfully';
			case 'contractorarchive':
					return 'The selected contractor(s) has been moved to inactive tab successfully';
			case 'contractorrestore':
				return 'The selected contractor(s) has been restored successfully';
			case 'supplierinvoicereject':
				return 'Request to reject the selected supplier invoice(s) has been sent';
			default:
				return msg;
		}
	}

}
